// extracted by mini-css-extract-plugin
export var colorSquare = "_ns-0";
export var container = "_ns-h";
export var danger = "_ns-5";
export var lightPink = "_ns-8";
export var neutralBlue = "_ns-7";
export var neutralYellow = "_ns-6";
export var normal = "_ns-1";
export var primary = "_ns-2";
export var primaryLight = "_ns-3";
export var selected = "_ns-i";
export var solidBlack = "_ns-g";
export var solidGreen = "_ns-b";
export var solidLightBlue = "_ns-d";
export var solidNavy = "_ns-c";
export var solidOrange = "_ns-f";
export var solidPink = "_ns-e";
export var solidRed = "_ns-9";
export var solidYellow = "_ns-a";
export var success = "_ns-4";